__turbopack_context__.v({
  "article": "post-card-module-scss-module__s_sSwq__article",
  "desc": "post-card-module-scss-module__s_sSwq__desc",
  "excerpt": "post-card-module-scss-module__s_sSwq__excerpt",
  "img-container": "post-card-module-scss-module__s_sSwq__img-container",
  "loading": "post-card-module-scss-module__s_sSwq__loading",
  "photo": "post-card-module-scss-module__s_sSwq__photo",
  "post-title": "post-card-module-scss-module__s_sSwq__post-title",
  "read-more": "post-card-module-scss-module__s_sSwq__read-more",
  "shine": "post-card-module-scss-module__s_sSwq__shine",
  "stats": "post-card-module-scss-module__s_sSwq__stats",
  "text": "post-card-module-scss-module__s_sSwq__text",
  "title": "post-card-module-scss-module__s_sSwq__title",
});
